const styles = () => ({
  badge: {
    backgroundColor: '#E25443',
    color: 'white'
  },
});

export default styles;